/**
 * @fileoverview Files Phase — parent route
 *
 * Purpose: Layout shell for the Files phase (the document library, surfaced
 * under the Gather Information sidebar section). Renders an `<Outlet />` so the
 * nested sub-route mounts its page content:
 *
 *   - gather.index → /gather (the document library)
 *
 * Books & Records was re-homed under Investigations (/review/books-and-records).
 *
 * URL: /dashboard/jobs/:jobId/gather
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Search-params contract (inherited by children):
 * - `documentId` — when present, the Library auto-opens the detail panel for
 *   that document on mount (deep-links from universal search / command palette).
 */
interface GatherSearch {
  documentId?: string;
}

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/gather",
)({
  component: GatherLayout,
  validateSearch: (search: Record<string, unknown>): GatherSearch => ({
    documentId:
      typeof search.documentId === "string" ? search.documentId : undefined,
  }),
});

function GatherLayout() {
  return <Outlet />;
}
